import { useEffect, useState } from "react";

// 전체화면 창 작업표시줄이 화면 상단/하단 중 어디에 붙을지. 기본은 상단.
export type WindowTaskbarPosition = "top" | "bottom";

const taskbarPositionStorageKey = "spawning-pool:taskbar-position";

// 작업표시줄 도킹 위치를 브라우저에 저장해 새로고침/다음 방문에도 유지한다. theme 선호와 같은 패턴.
export function useWindowTaskbarPositionPreference(): readonly [
  WindowTaskbarPosition,
  (position: WindowTaskbarPosition) => void,
] {
  const [position, setPosition] = useState<WindowTaskbarPosition>(
    () => readStoredPosition() ?? "top",
  );

  useEffect(() => {
    try {
      window.localStorage.setItem(taskbarPositionStorageKey, position);
    } catch {
      // Storage can be unavailable in private or restricted browser contexts.
    }
  }, [position]);

  return [position, setPosition] as const;
}

function readStoredPosition(): WindowTaskbarPosition | null {
  try {
    const value = window.localStorage.getItem(taskbarPositionStorageKey);
    return value === "top" || value === "bottom" ? value : null;
  } catch {
    return null;
  }
}
